<template>
  <pui-theme-provider id="evo-app" :theme="platformTheme" class="pui-wrapper">
    <pui-common-spinner
      v-if="showAppSpinner"
      :message="loadingMessage"
      fullscreen
    ></pui-common-spinner>
    <router-view v-else />
  </pui-theme-provider>
</template>

<script>
import services from './core/services';
import { LanguagesManagerService } from './core/services/languagesManagerService';
import platformTheme from './platform/theme';
import Browsers from './utils/browsers';

export default {
  data() {
    return {
      platformTheme,
    };
  },
  computed: {
    /**
     * @returns {boolean} if the languages are loading
     */
    isLoadingLanguages() {
      return LanguagesManagerService.getLoadingLanguages();
    },
    /**
     * @returns {boolean} if any of the module settings is loading
     */
    isLoadingSettings() {
      return services.getService('applications').getIsLoading();
    },
    /**
     * @returns {boolean} if the global app spinner should be shown
     */
    showAppSpinner() {
      return this.isLoadingLanguages || this.isLoadingSettings;
    },
    /**
     * @returns {string} the global app loading message
     */
    loadingMessage() {
      return this.isLoadingLanguages ? 'Loading...' : this.$t('platform.app.loading');
    },
  },
  mounted() {
    // Check if the browser is supported.
    if (Browsers.isSupportedBrowser() === false) {
      this.$router.push({ name: 'browserVersionError' });
    }
    services.onAppMount();

    // Init languages on app start
    LanguagesManagerService.initializeLanguages().catch(err => {
      this.$router.push({ name: 'applicationError' });
    });

    // Start analytics service
    services.getService('analytics').start();
  },
};
</script>
